export function formatDate(input: string, locale?: string): string {
  locale = locale ?? "en-US";
  const date = new Date(input);
  return date.toLocaleDateString(locale, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}